import { pdf } from '@react-pdf/renderer';

import NotePdfDocument, {
  Note,
} from '@/components/PdfReader/GeneratePdf/NotePdfDocument';

export async function generateAndDownloadPdf({
  notes,
  title,
  author,
  landingPageUrl = '',
}: {
  notes: Note[];
  title: string;
  author: string;
  landingPageUrl?: string;
}) {
  const blob = await pdf(
    <NotePdfDocument
      notes={notes}
      title={title}
      author={author}
      landingPageUrl={landingPageUrl}
    />,
  ).toBlob();

  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `${title.replace(/\s+/g, '_')}_Notes.pdf`;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}
